<mat-sidenav-container
   (backdropClick)="bookmarks.close(); sidenav.close()"
   [hasBackdrop]="activeScreenSize() === 'xs'"
   class="w-full h-full"
>
   <mat-sidenav
      #sidenav
      [class]="{
         'drawer-open': drawerExpanded(),
         'shadow-none': !drawerExpanded(),
      }"
      [disableClose]="true"
      [opened]="activeScreenSize() !== 'xs'"
      class="mat-elevation-z3 overflow-hidden rounded-tr-lg transitionsEnabled"
      id="drawer"
      mode="over"
   >
      <webvis-ui-main-drawer
         (isOpenChange)="drawerExpanded.set($event)"
         (navigate)="activeScreenSize() === 'xs' && sidenav.close()"
      ></webvis-ui-main-drawer>
   </mat-sidenav>

   <mat-sidenav
      #bookmarks
      (openedChange)="changeTabDrawerOpen($event)"
      [disableClose]="true"
      [mode]="activeScreenSize() === 'xl' ? 'side' : 'over'"
      [opened]="tabDrawerOpen()"
      class="bg-surface-container-lowest w-full md:w-1/2 lg:w-1/3 xl:w-96 border-l border-outlineVariant rounded-none"
      position="end"
   >
      <webvis-ui-page-history
         (closeHistory)="bookmarks.close()"
         (navigateToPage)="bookmarks.close()"
         [activeScreenSize]="activeScreenSize()"
      ></webvis-ui-page-history>
   </mat-sidenav>

   <mat-sidenav-content>
      <div class="flex flex-col h-full overflow-hidden">
         <webvis-ui-page-header
            (openTimeRegistrationDialog)="openTimeRegistrationDialog()"
            (toggleBookmark)="headerToggleBookmark()"
            [isBookmarked]="currentPageIsBookmarked()"
         >
            <webvis-feature-quick-create-menu
               class="mr-1"
               globalAddButton
            ></webvis-feature-quick-create-menu>
         </webvis-ui-page-header>

         <div class="flex flex-col flex-auto overflow-hidden px-4 pt-4 bg-surface border-l border-t border-outlineVariant rounded-tl-lg">
            <router-outlet></router-outlet>
         </div>
      </div>
   </mat-sidenav-content>
</mat-sidenav-container>

<webvis-ui-fab-buttons class="z-10 absolute bottom-0 right-0"></webvis-ui-fab-buttons>

<!-- Custom popover template for the ngx-ui-tour guided tour. Lives in the always-present shell so steps on
     any page/dialog can render. Custom (not the library default) because that default uses the Material
     Icons font, which this app doesn't load — so its icons render as raw text. Uses FontAwesome instead. -->
<tour-step-template>
   <ng-template let-step="step">
      <div
         (click)="$event.stopPropagation()"
         class="flex flex-col gap-2 p-4 w-80 max-w-[80vw]"
      >
         <div class="flex items-start justify-between gap-2">
            <h3 class="m-0 text-base font-semibold text-onSurface">{{ step.title }}</h3>
            <button
               (click)="tourService.end()"
               [attr.aria-label]="'general.close' | translate"
               class="-mr-2 -mt-1 shrink-0"
               mat-icon-button
            >
               <fa-icon [icon]="['far', 'xmark']" />
            </button>
         </div>

         <div
            [innerHTML]="step.content"
            class="text-sm text-onSurfaceVariant"
         ></div>

         <div class="mt-2 flex items-center justify-between gap-2">
            @if (tourService.hasPrev(step)) {
               <button
                  (click)="tourService.prev()"
                  mat-button
               >
                  <fa-icon [icon]="['far', 'chevron-left']" />
                  {{ step.prevBtnTitle }}
               </button>
            } @else {
               <span></span>
            }

            <span class="text-xs text-onSurfaceVariant">{{ tourService.steps.indexOf(step) + 1 }} / {{ tourService.steps.length }}</span>

            @if (tourService.hasNext(step) && !step.nextOnAnchorClick) {
               <button
                  (click)="tourService.next()"
                  color="primary"
                  matButton="tonal"
               >
                  {{ step.nextBtnTitle }}
                  <fa-icon [icon]="['far', 'chevron-right']" />
               </button>
            } @else if (!tourService.hasNext(step)) {
               <button
                  (click)="tourService.end()"
                  color="primary"
                  matButton="tonal"
               >
                  {{ step.endBtnTitle }}
               </button>
            } @else {
               <span></span>
            }
         </div>
      </div>
   </ng-template>
</tour-step-template>
